import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { ChatMessage } from '../models';
import { isIBHandled } from '../models/ib-queues-handled-chat-data';

@Component({
  selector: 'lib-ibqueue-handled-message',
  templateUrl: './ibqueue-handled-message.component.html',
  styles: [
    `
      .extra-small {
        font-size: 60%;
      }

      .total-row {
        border-top: 2px solid black !important;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IBQueueHandledMessageComponent {
  @Input() msg!: ChatMessage;
  isIBHandled = isIBHandled;

  constructor() {}
}
